import { Box, useMediaQuery, useTheme } from "@mui/material";

import imgBanner0 from '../../../assets/banner/banner0.jpg';
import imgBanner2 from '../../../assets/banner/banner2.webp';
import imgBanner3 from '../../../assets/banner/banner3.jpg';
import imgBanner4 from '../../../assets/banner/banner4.webp';

import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import SectionCards from "./SectionCards";



const SectionHero = () => {
  const images = [imgBanner0, imgBanner2, imgBanner3, imgBanner4]

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (<Box
    component={'section'}
    sx={{
      width: '100%',
      position: 'relative',
      padding: '60px 0 0 0',
    }}
  >
    <div aria-label="bannerinfo">

      <Swiper spaceBetween={50} slidesPerView={1} modules={[Autoplay, EffectFade]} effect={'fade'} autoplay={{ delay: 30500, disableOnInteraction: false }} style={{ zIndex: 0, marginTop: '-4rem', maxHeight: isMobile ? '10rem' : '20rem' }}>
        {
          images && images.map((foto, index) => {
            return (
              <SwiperSlide key={`photo-client-number-${index}`}>
                <div style={{ position: 'relative' }}>
                  <div style={{ position: 'absolute', top: -5, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0)' }}></div>
                  <img src={foto} alt='foto-cliente' style={{ width: '100%', height: '400px', objectFit: 'cover' }} />
                </div>
              </SwiperSlide>
            );
          })
        }
      </Swiper>

      {/* <Grid container maxWidth="lg" justifyContent={'space-arround'} sx={{ margin: '0 auto'}}>
                <Grid item xs={12} md={7} sx={{ padding: '3rem'  }}>
                    <Typography variant="h3" sx={{ fontWeight: 'bold'}}

                    >Somos PyM Gestiones</Typography>
                    <Typography component={'p'} sx={{ fontSize: '2.2ch', pt: '1rem'}}>Brindamos consultoría inmobiliaria personalizada y gestionamos trámites para simplificar y agilizar procesos de Compra y Venta.</Typography>
                </Grid>
                <Grid item xs={12} md={5} sx={{ textAlign: 'center' }}>
                    <img src={imgHero} alt="hero" style={{ width: '70%', marginBottom: '3rem' }} />
                </Grid>
            </Grid> */}


    </div>


    <Box aria-label="informes"
      sx={{

        position: 'relative',
        paddingBottom: '60px',
        '&::before': {
          content: '""',
          position: isMobile ? 'relative' : 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '50%',

          zIndex: 0,
        }

      }}>

      <SectionCards />

    </Box>
  </Box >);
}

export default SectionHero;